export default __webpack_public_path__ + "static/media/anxietyCard.047ff89a.png";